import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  update(event) {
    const radio = event.target
    const group = radio.closest("div")
    if (!group) return

    // Reset all labels in this group
    group.querySelectorAll("label span").forEach(span => {
      span.classList.remove("ring-2")
    })

    // Highlight the selected one
    const label = radio.closest("label")
    if (label) {
      const span = label.querySelector("span")
      if (span) {
        span.classList.add("ring-2")
      }
    }
  }
}
